'use client';

import { doc, getDoc } from 'firebase/firestore';
import { db } from '@/lib/firebase';
import type { DeliverySettings } from '@/lib/types';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';

export default function DeliveryTimesPage() {
    const [deliverySettings, setDeliverySettings] = useState<DeliverySettings | null>(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const getDeliveryData = async () => {
            try {
                const deliverySettingsDoc = await getDoc(doc(db, 'settings', 'delivery'));
                if (deliverySettingsDoc.exists()) {
                    setDeliverySettings(deliverySettingsDoc.data() as DeliverySettings);
                }
            } catch (error) {
                console.error("Error fetching delivery settings:", error);
            } finally {
                setIsLoading(false);
            }
        };
        getDeliveryData();
    }, []);


    if (isLoading) {
        return <div className="flex h-[80vh] items-center justify-center"><Loader2 className="h-16 w-16 animate-spin" /></div>;
    }

    return (
        <div className="container mx-auto py-12 px-4">
            <div className="max-w-4xl mx-auto">
                <h1 className="text-3xl md:text-4xl font-bold font-headline mb-4 text-center">Horários de Entrega</h1>
                <p className="text-muted-foreground text-center mb-10">Confira nossos horários de entrega agendada para cada cidade.</p>
                
                {deliverySettings && deliverySettings.cities.length > 0 ? (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                        {deliverySettings.cities.map(city => (
                            <Card key={city.id}>
                                <CardHeader>
                                    <CardTitle className="text-primary">{city.name}</CardTitle>
                                </CardHeader>
                                <CardContent>
                                    {city.routes && city.routes.length > 0 ? (
                                        <ul className="space-y-2">
                                            {city.routes.map((route, index) => (
                                                <li key={index} className="flex justify-between items-center text-muted-foreground border-b border-dashed pb-1">
                                                    <span>Rota das {route.time}</span>
                                                    {route.cutoffTime && <span className="text-xs">(pedidos até {route.cutoffTime})</span>}
                                                </li>
                                            ))}
                                        </ul>
                                    ) : (
                                        <p className="text-muted-foreground">Nenhuma rota de entrega agendada para esta cidade.</p>
                                    )}
                                    <p className="text-sm mt-4 text-primary font-semibold">Taxa de entrega: R$ {city.fee.toFixed(2)}</p>
                                </CardContent>
                            </Card>
                        ))}
                    </div>
                ) : (
                    <p className="text-center text-muted-foreground">Nenhum horário de entrega configurado no momento.</p>
                )}

                 <div className="text-center mt-12 p-6 bg-card rounded-lg border">
                     <h2 className="text-2xl font-bold text-primary">Também oferecemos Envio Imediato!</h2>
                     <p className="text-lg mt-2 text-muted-foreground">Receba seu pedido em minutos (consulte taxas no checkout).</p>
                </div>
            </div>
        </div>
    );
}
